/**
 * مشغل فيديوهات المؤثرين
 */
class InfluencerVideosPlayer {
  constructor(containerId, api) {
    this.container = document.getElementById(containerId);
    this.api = api;
    this.videoData = [];
    this.activeIndex = 0;
    this.isLoading = false;
    this.shortsModal = null;
    this.shortsScroller = null;
    
    // إنشاء العناصر اللازمة
    this.init();
  }

  /**
   * تهيئة المشغل
   */
  init() {
    // إنشاء واجهة العرض الأساسية
    this.setupUI();
    
    // تحميل البيانات
    this.loadData();
    
    // إضافة مستمعات الأحداث
    this.setupEventListeners();
  }

  /**
   * إعداد واجهة المستخدم
   */
  setupUI() {
    // العنوان
    const title = this.container.querySelector('.section-title');
    
    // قائمة تمرير الفيديوهات
    const videoScroller = this.container.querySelector('#videoScroller');
    
    // إنشاء نافذة الشورتس إذا لم تكن موجودة
    this.shortsModal = this.container.querySelector('#shortsModal');
    
    // إزالة أي مؤشر حالة موجود
    const statusBar = this.container.querySelector('.status-bar');
    if (statusBar) {
      statusBar.remove();
    }
  }

  /**
   * تحميل البيانات من واجهة برمجة التطبيقات
   */
  async loadData() {
    try {
      this.isLoading = true;
      
      // جلب جميع بيانات فيديوهات المؤثرين
      this.videoData = await this.api.getAllInfluencerVideosData();
      
      // طباعة البيانات للتشخيص
      console.log('بيانات الفيديوهات:', this.videoData);
      
      // تحويل أسماء المنتجات للعربية إذا أمكن
      this.videoData.forEach(item => {
        if (item.video && item.video.sources && item.video.sources.length > 0) {
          item.video.sources = item.video.sources.map(source => {
            return {
              ...source,
              url: this.validateAndFixVideoUrl(source.url)
            };
          });
        }
        
        // تحويل عناوين المنتجات إلى العربية (إذا كانت متوفرة)
        if (item.products && item.products.length > 0) {
          item.products.forEach(product => {
            // لتشخيص البيانات المتوفرة للمنتج
            console.log('بيانات المنتج الأصلية:', product);
            
            // نسخ العنوان الإنجليزي إلى title_en للاحتفاظ به
            if (product.title) {
              product.title_en = product.title;
            }
            
            // إذا كان المنتج يحتوي على عنوان عربي، استخدمه
            if (product.title_ar) {
              product.title = product.title_ar;
            } else if (product.titleAr) {
              product.title = product.titleAr;
            } else if (product.title_arabic) {
              product.title = product.title_arabic;
            } else if (product.arabicTitle) {
              product.title = product.arabicTitle;
            } else if (product.metafields && product.metafields.title_ar) {
              product.title = product.metafields.title_ar;
            }
            // وإلا سنبقي على العنوان الإنجليزي
          });
        }
      });
      
      // عرض البيانات
      this.renderVideoCards();
      
      this.isLoading = false;
    } catch (error) {
      console.error('خطأ في تحميل البيانات:', error);
      this.isLoading = false;
    }
  }

  /**
   * عرض بطاقات الفيديو
   */
  renderVideoCards() {
    const videoScroller = this.container.querySelector('#videoScroller');
    if (!videoScroller) return;
    
    // مسح المحتوى الحالي
    videoScroller.innerHTML = '';
    
    // إذا لم تكن هناك بيانات
    if (!this.videoData || this.videoData.length === 0) {
      videoScroller.innerHTML = '<div class="no-videos">لم يتم العثور على فيديوهات</div>';
      return;
    }
    
    // إنشاء بطاقات الفيديو
    this.videoData.forEach((data, index) => {
      // التأكد من وجود بيانات ضرورية
      if (!data.video || !data.video.sources || data.video.sources.length === 0) {
        return;
      }
      
      const videoWrapper = document.createElement('div');
      videoWrapper.className = 'video-wrapper';
      
      // الحصول على أفضل مصدر للفيديو (نختار الجودة المتوسطة لتوفير المساحة)
      const videoSource = this.getBestVideoSource(data.video.sources);
      
      // الحصول على معلومات المؤثر
      const influencerName = data.influencer ? data.influencer.name : 'مؤثر';
      const socialLink = data.influencer && data.influencer.socialAccounts && data.influencer.socialAccounts.length > 0 
        ? data.influencer.socialAccounts[0] 
        : '#';
      
      // فحص ما إذا كان URL صالحاً
      const videoUrl = this.validateAndFixVideoUrl(videoSource.url);
      
      // إنشاء HTML للبطاقة مباشرة مع إعداد preload="metadata" بدلاً من none
      videoWrapper.innerHTML = `
        <a href="${socialLink}" target="_blank" class="instagram-bar">
          <span class="instagram-icon">📸</span>
          <span class="instagram-username">${influencerName}</span>
        </a>
        <div class="video-card" data-index="${index}">
          <div class="video-thumbnail">
            <video preload="metadata">
              <source src="${videoUrl}" type="${videoSource.mimeType}">
            </video>
            <div class="play-icon"></div>
          </div>
        </div>
      `;
      
      videoScroller.appendChild(videoWrapper);
    });
    
    // إضافة مستمعات الأحداث للبطاقات
    this.setupCardEventListeners();
  }

  /**
   * الحصول على صورة مصغرة مناسبة
   */
  getThumbnailImage(data) {
    // الترتيب: 1. صورة الفيديو الافتراضية، 2. اللقطة الأولى من الفيديو، 3. صورة المنتج، 4. صورة افتراضية
    
    // 1. التحقق من وجود صورة الفيديو الافتراضية
    if (data.video && data.video.previewImage && data.video.previewImage.url) {
      const url = this.validateAndFixImageUrl(data.video.previewImage.url);
      if (url) return url;
    }
    
    // 2. محاولة استخدام اللقطة الأولى من الفيديو
    if (data.video && data.video.sources && data.video.sources.length > 0) {
      const videoSource = data.video.sources[0];
      const videoUrl = videoSource.url || '';
      const videoId = this.extractVideoId(videoUrl);
      
      if (videoId) {
        // محاولة عدة تنسيقات محتملة للصورة المصغرة
        const possibleThumbnails = [
          `https://cdn.shopify.com/videos/c/vp/${videoId}/${videoId}.jpg`,
          `https://cdn.shopify.com/videos/c/vp/${videoId}/thumbnail.jpg`,
          `https://cdn.shopify.com/videos/c/vp/${videoId}/poster.jpg`,
          `https://cdn.shopify.com/videos/c/vp/${videoId}/preview.jpg`,
          `https://cdn.shopify.com/videos/c/o/${videoId}/thumbnail.jpg`,
          `https://cdn.shopify.com/videos/c/o/${videoId}/poster.jpg`
        ];
        
        return possibleThumbnails[0];
      }
    }
    
    // 3. استخدام صورة المنتج كخيار ثالث
    if (data.products && data.products.length > 0 && data.products[0].featuredImage) {
      const url = this.validateAndFixImageUrl(data.products[0].featuredImage.url);
      if (url) return url;
    }
    
    // 4. إرجاع صورة افتراضية عامة
    return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjMyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzIwIiBoZWlnaHQ9IjMyMCIgZmlsbD0iIzMzMyIvPjxjaXJjbGUgY3g9IjE2MCIgY3k9IjE2MCIgcj0iNDAiIGZpbGw9IiNmZmYiLz48cG9seWdvbiBwb2ludHM9IjE0MCwxNDAgMTkwLDE2MCAxNDAsMTgwIiBmaWxsPSIjMzMzIi8+PC9zdmc+';
  }
  
  /**
   * التحقق من صحة وإصلاح رابط الصورة
   */
  validateAndFixImageUrl(url) {
    if (!url) return '';
    
    // 1. الروابط التي تبدأ بـ //
    if (url.startsWith('//')) {
      return 'https:' + url;
    }
    
    // 2. إذا كان الرابط يحتوي على cdn.shopify.com ولكن لا يحتوي على https://
    if (url.includes('cdn.shopify.com') && !url.startsWith('http')) {
      return 'https://' + url;
    }
    
    // 3. إذا كان الرابط بصيغة gid://shopify/MediaImage/
    if (url.includes('gid://shopify/MediaImage/')) {
      const imageId = url.split('/').pop();
      return `https://cdn.shopify.com/assets/images/${imageId}.jpg`;
    }
    
    // إرجاع الرابط كما هو إذا كان صحيحًا
    return url;
  }

  /**
   * التحقق من صحة وإصلاح رابط الفيديو
   */
  validateAndFixVideoUrl(url) {
    if (!url) return '';
    
    // ملاحظة جميع المحاولات لتصحيح الرابط
    console.log('محاولة إصلاح رابط الفيديو:', url);
    
    // 1. الروابط التي تبدأ بـ //
    if (url.startsWith('//')) {
      return 'https:' + url;
    }
    
    // 2. إذا كان الرابط يحتوي على cdn.shopify.com ولكن لا يحتوي على https://
    if (url.includes('cdn.shopify.com') && !url.startsWith('http')) {
      return 'https://' + url;
    }
    
    // 3. بناء الرابط من معرف فيديو Shopify إذا كان الرابط يبدو كمعرف
    if (url.includes('gid://shopify/Video/')) {
      const videoId = url.split('/').pop();
      console.log('تم استخراج معرف الفيديو:', videoId);
      return `https://cdn.shopify.com/videos/c/vp/${videoId}/${videoId}.mp4`;
    }
    
    // 4. محاولة استخراج معرف الفيديو من الرابط الحالي
    const videoIdMatch = url.match(/\/videos\/c\/[vo]\/([a-z0-9_-]+)/i);
    if (videoIdMatch && videoIdMatch[1]) {
      const videoId = videoIdMatch[1];
      console.log('تم استخراج معرف الفيديو من الرابط:', videoId);
      return `https://cdn.shopify.com/videos/c/vp/${videoId}/${videoId}.mp4`;
    }
    
    // 5. إذا كان الرابط ينتهي بـ .m3u8، نحاول استخدام MP4 بدلاً من ذلك
    if (url.endsWith('.m3u8')) {
      return url.replace('.m3u8', '.mp4');
    }
    
    // إرجاع الرابط كما هو إذا لم نتمكن من إصلاحه
    return url;
  }

  /**
   * الحصول على أفضل مصدر للفيديو
   */
  getBestVideoSource(sources) {
    if (!sources || sources.length === 0) {
      return { url: '', mimeType: 'video/mp4' };
    }
    
    // ترتيب المصادر حسب الجودة (نفضل mp4 متوسط الجودة)
    const mp4Sources = sources.filter(s => s.format === 'mp4');
    
    if (mp4Sources.length === 0) {
      // إذا لم يكن هناك مصادر mp4، استخدم أول مصدر متاح
      return sources[0];
    }
    
    // ترتيب حسب الدقة (نفضل 720p)
    const preferredHeight = 720;
    const sortedSources = [...mp4Sources].sort((a, b) => {
      return Math.abs(a.height - preferredHeight) - Math.abs(b.height - preferredHeight);
    });
    
    return sortedSources[0];
  }

  /**
   * إضافة مستمعات الأحداث للبطاقات
   */
  setupCardEventListeners() {
    const videoCards = this.container.querySelectorAll('.video-card');
    
    videoCards.forEach(card => {
      card.addEventListener('click', () => {
        const index = parseInt(card.dataset.index);
        this.openShortsModal(index);
      });
    });
  }

  /**
   * إعداد مستمعات الأحداث العامة
   */
  setupEventListeners() {
    // تنظيف مستمعات الأحداث عند إغلاق النافذة
    window.addEventListener('beforeunload', () => {
      this.cleanup();
    });
  }

  /**
   * تنظيف مستمعات الأحداث والموارد
   */
  cleanup() {
    if (this.shortsScroller) {
      const videos = this.shortsScroller.querySelectorAll('video');
      videos.forEach(video => {
        video.pause();
        video.removeAttribute('src');
        video.load();
      });
    }
  }

  /**
   * فتح نافذة الشورتس
   */
  openShortsModal(index) {
    this.activeIndex = index;
    
    // إنشاء عناصر الفيديو
    this.createShortsItems();
    
    // عرض النافذة
    this.shortsModal.style.display = 'block';
    
    // مرر إلى الفيديو المحدد
    const items = this.shortsScroller.querySelectorAll('.shorts-item');
    
    // تأكد من أن هناك عناصر للتمرير إليها
    if (items.length > 0 && items[index]) {
      setTimeout(() => {
        items[index].scrollIntoView({ behavior: 'auto' });
        items[index].classList.add('active');
        
        // بداية تشغيل الفيديو بعد التحميل
        this.playActiveVideo(index);
      }, 100);
    }
    
    // عرض توضيح السكرول
    const swipeGuide = this.shortsModal.querySelector('#swipeGuide');
    if (swipeGuide) {
      swipeGuide.classList.add('visible');
    }
    
    // بدء رصد التمرير
    this.observeScrolling();
  }

  /**
   * إنشاء عناصر الشورتس
   */
  createShortsItems() {
    this.shortsScroller = this.shortsModal.querySelector('#shortsScroller');
    if (!this.shortsScroller) return;
    
    this.shortsScroller.innerHTML = '';
    
    this.videoData.forEach((data, index) => {
      // التأكد من وجود بيانات ضرورية
      if (!data.video || !data.video.sources || data.video.sources.length === 0) {
        return;
      }
      
      const shortsItem = document.createElement('div');
      shortsItem.className = 'shorts-item';
      shortsItem.dataset.index = index;
      
      // الحصول على أفضل مصدر للفيديو (نختار الجودة العالية للعرض)
      const videoSource = this.getBestVideoSourceForPlayback(data.video.sources);
      
      // التأكد من صحة الرابط
      const videoUrl = this.validateAndFixVideoUrl(videoSource.url);
      
      // الفيديو الرئيسي - نستخدم preload="metadata" لتحميل البيانات الوصفية
      const video = document.createElement('video');
      video.className = 'shorts-video';
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      // استخدام poster فقط إذا كانت صورة المعاينة متوفرة
      const previewImageUrl = data.video.previewImage && data.video.previewImage.url 
        ? this.validateAndFixImageUrl(data.video.previewImage.url) 
        : '';
      
      if (previewImageUrl) {
        video.setAttribute('poster', previewImageUrl);
      }
      
      // إضافة رابط الفيديو مباشرة
      const source = document.createElement('source');
      source.src = videoUrl;
      source.type = videoSource.mimeType || 'video/mp4';
      video.appendChild(source);
      
      // إضافة معالج للأخطاء
      video.addEventListener('error', (e) => {
        console.error('خطأ في تحميل الفيديو:', e);
        const errorMessage = document.createElement('div');
        errorMessage.className = 'video-error-message';
        errorMessage.textContent = 'تعذر تشغيل الفيديو';
        shortsItem.appendChild(errorMessage);
        
        // محاولة تحميل الفيديو باستخدام طريقة أخرى
        const videoId = this.extractVideoId(videoUrl);
        if (videoId) {
          const altSource = document.createElement('source');
          altSource.src = `https://cdn.shopify.com/videos/c/vp/${videoId}/${videoId}.HD-1080p-7.2Mbps.mp4`;
          altSource.type = 'video/mp4';
          video.innerHTML = '';
          video.appendChild(altSource);
          video.load();
        }
      });
      
      // المحتوى
      const content = document.createElement('div');
      content.className = 'shorts-content';
      
      // معلومات المؤثر
      if (data.influencer) {
        const influencerName = data.influencer.name || 'مؤثر';
        const socialLink = data.influencer.socialAccounts && data.influencer.socialAccounts.length > 0 
          ? data.influencer.socialAccounts[0] 
          : '#';
          
        const accountInfo = document.createElement('a');
        accountInfo.className = 'account-info';
        accountInfo.href = socialLink;
        accountInfo.target = '_blank';
        
        const avatar = document.createElement('div');
        avatar.className = 'account-avatar';
        
        // إذا كانت هناك صورة للمؤثر
        if (data.influencer.photoUrl) {
          avatar.innerHTML = `<img src="${data.influencer.photoUrl}" alt="${influencerName}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
        } else {
          avatar.innerHTML = '📸';
        }
        
        const name = document.createElement('div');
        name.className = 'account-name';
        name.textContent = influencerName;
        
        accountInfo.appendChild(avatar);
        accountInfo.appendChild(name);
        content.appendChild(accountInfo);
      }
      
      // معلومات المنتجات (عرض متعدد المنتجات)
      if (data.products && data.products.length > 0) {
        // إنشاء حاوية المنتجات
        const productsContainer = document.createElement('div');
        productsContainer.className = 'products-container';
        
        // إضافة كل منتج مرتبط
        data.products.forEach(product => {
          const productInfo = document.createElement('a');
          productInfo.className = 'product-info';
          productInfo.href = `/products/${product.handle}`;
          productInfo.target = '_blank';
          
          // إضافة صورة المنتج مع تأثير حركي للدوائر
          if (product.featuredImage && product.featuredImage.url) {
            const productImage = document.createElement('div');
            productImage.className = 'product-image-container';
            
            // إضافة الدوائر للتأثير الحركي
            for (let i = 0; i < 3; i++) {
              const circle = document.createElement('div');
              circle.className = `product-image-circle circle-${i+1}`;
              productImage.appendChild(circle);
            }
            
            // إضافة صورة المنتج
            const img = document.createElement('img');
            img.src = product.featuredImage.url;
            img.alt = product.title;
            img.className = 'product-image';
            productImage.appendChild(img);
            
            productInfo.appendChild(productImage);
          }
          
          const productTitle = document.createElement('div');
          productTitle.className = 'product-title';
          
          // إضافة كلمة "عطر" قبل الاسم
          productTitle.textContent = `عطر ${product.title}`;
          
          productInfo.appendChild(productTitle);
          productsContainer.appendChild(productInfo);
        });
        
        content.appendChild(productsContainer);
      }
      
      // شريط التقدم
      const progressContainer = document.createElement('div');
      progressContainer.className = 'progress-container';
      
      const progressBarContainer = document.createElement('div');
      progressBarContainer.className = 'progress-bar-container';
      
      const progressBar = document.createElement('div');
      progressBar.className = 'progress-bar';
      
      const progressHandle = document.createElement('div');
      progressHandle.className = 'progress-bar-handle';
      
      const videoTimeContainer = document.createElement('div');
      videoTimeContainer.className = 'video-time-container';
      
      const currentTime = document.createElement('div');
      currentTime.className = 'video-time current-time';
      currentTime.textContent = '0:00';
      
      const totalTime = document.createElement('div');
      totalTime.className = 'video-time total-time';
      totalTime.textContent = '0:00';
      
      progressBarContainer.appendChild(progressBar);
      progressBarContainer.appendChild(progressHandle);
      videoTimeContainer.appendChild(currentTime);
      videoTimeContainer.appendChild(totalTime);
      progressContainer.appendChild(progressBarContainer);
      progressContainer.appendChild(videoTimeContainer);
      
      content.appendChild(progressContainer);
      
      shortsItem.appendChild(video);
      shortsItem.appendChild(content);
      this.shortsScroller.appendChild(shortsItem);
      
      // إضافة وظائف التحكم
      this.setupVideoControls(shortsItem, video, progressBar, progressBarContainer, progressHandle, currentTime, totalTime);
    });
    
    // إعداد زر الإغلاق
    const closeButton = this.shortsModal.querySelector('.close-button');
    if (closeButton) {
      // إزالة جميع مستمعات الأحداث السابقة
      const newCloseButton = closeButton.cloneNode(true);
      closeButton.parentNode.replaceChild(newCloseButton, closeButton);
      
      // إضافة مستمع جديد
      newCloseButton.addEventListener('click', () => {
        this.closeShortsModal();
      });
    }
  }

  /**
   * استخراج معرف الفيديو من الرابط
   */
  extractVideoId(url) {
    if (!url) return null;
    
    // معالجة الروابط التي تحتوي على gid://shopify/Video/
    if (url.includes('gid://shopify/Video/')) {
      const id = url.split('/').pop();
      return id;
    }
    
    // معالجة الروابط التي تحتوي على /videos/c/vp/
    const match = url.match(/\/videos\/c\/[vo]p\/([a-zA-Z0-9_-]+)/i);
    if (match && match[1]) {
      return match[1];
    }
    
    // معالجة الروابط التي تنتهي بـ .mp4 أو .m3u8
    const fileMatch = url.match(/\/([a-zA-Z0-9_-]+)(?:\.HD-\d+p-[\d.]+Mbps)?\.(?:mp4|m3u8)/i);
    if (fileMatch && fileMatch[1]) {
      return fileMatch[1];
    }
    
    // محاولة استخراج أي معرف رقمي أو نصي يمكن أن يكون معرّف للفيديو
    const idMatch = url.match(/([a-zA-Z0-9_-]{6,})/);
    if (idMatch && idMatch[1]) {
      return idMatch[1];
    }
    
    return null;
  }

  /**
   * الحصول على أفضل مصدر للفيديو للتشغيل الكامل
   */
  getBestVideoSourceForPlayback(sources) {
    if (!sources || sources.length === 0) {
      return { url: '', mimeType: 'video/mp4' };
    }
    
    // ترتيب المصادر mp4 حسب الجودة (نفضل الجودة العالية)
    const mp4Sources = sources.filter(s => s.format === 'mp4');
    
    if (mp4Sources.length === 0) {
      // إذا لم يكن هناك مصادر mp4، استخدم أول مصدر متاح
      return sources[0];
    }
    
    // ترتيب حسب الدقة (نفضل أعلى دقة متاحة)
    const sortedSources = [...mp4Sources].sort((a, b) => b.height - a.height);
    
    return sortedSources[0];
  }

  /**
   * إعداد عناصر التحكم للفيديو
   */
  setupVideoControls(item, video, progressBar, progressBarContainer, progressHandle, currentTimeElement, totalTimeElement) {
    const playPauseIndicator = this.shortsModal.querySelector('.play-pause-indicator');
    if (!playPauseIndicator) return;
    
    // سجل للتعقب إذا كان الفيديو جاهزًا للتشغيل
    let isReady = false;
    
    // دالة للتحقق من أحداث الفيديو الرئيسية
    video.addEventListener('loadedmetadata', function() {
      isReady = true;
      totalTimeElement.textContent = formatTime(video.duration);
    });
    
    // بدء التشغيل فقط عندما يكون الفيديو جاهزًا
    video.addEventListener('canplay', function() {
      if (video.paused && item.classList.contains('active')) {
        try {
          video.play().catch(err => console.error('خطأ في تشغيل الفيديو:', err));
        } catch (e) {
          console.error('استثناء في تشغيل الفيديو:', e);
        }
      }
    });
    
    // التشغيل عند النقر
    item.addEventListener('click', function(e) {
      // تجاهل النقر على الروابط وشريط التقدم
      if (e.target.closest('.account-info') || e.target.closest('.product-info') || e.target.closest('.progress-container')) {
        return;
      }
      
      togglePlayPause(video);
    });
    
    // تبديل حالة التشغيل/الإيقاف بطريقة أكثر أمانًا
    function togglePlayPause(video) {
      if (!isReady && !video.src) {
        // محاولة تحديث المصدر إذا كان فارغاً
        const sources = video.querySelectorAll('source');
        if (sources.length > 0) {
          video.load();
        }
      }
      
      if (video.paused) {
        // استخدام Promise للتعامل مع تشغيل الفيديو
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
          playPromise.then(() => {
            showPlayPauseIndicator(false);
          }).catch(error => {
            console.error('خطأ في تشغيل الفيديو:', error);
          });
        }
      } else {
        try {
          video.pause();
          showPlayPauseIndicator(true);
        } catch (e) {
          console.error('خطأ في إيقاف الفيديو:', e);
        }
      }
    }
    
    // عرض مؤشر التشغيل/الإيقاف
    function showPlayPauseIndicator(isPaused) {
      if (!playPauseIndicator) return;
      
      const iconElement = playPauseIndicator.querySelector('.icon');
      const textElement = playPauseIndicator.querySelector('.text');
      
      if (!iconElement || !textElement) return;
      
      playPauseIndicator.classList.remove('active');
      
      if (isPaused) {
        iconElement.textContent = '▶';
        textElement.textContent = 'توقف';
      } else {
        iconElement.textContent = '⏸';
        textElement.textContent = 'تشغيل';
      }
      
      setTimeout(() => {
        playPauseIndicator.classList.add('active');
      }, 10);
    }
    
    // تحديث عرض الوقت والتقدم
    video.addEventListener('timeupdate', function() {
      if (isNaN(video.duration)) return;
      
      // تحديث شريط التقدم
      const percentage = (video.currentTime / video.duration) * 100;
      progressBar.style.width = percentage + '%';
      progressHandle.style.left = percentage + '%';
      
      // تحديث عرض الوقت
      currentTimeElement.textContent = formatTime(video.currentTime);
      totalTimeElement.textContent = formatTime(video.duration);
    });
    
    // تنسيق الوقت: تحويل الثواني إلى تنسيق 0:00
    function formatTime(seconds) {
      if (isNaN(seconds)) return '0:00';
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      return minutes + ':' + (remainingSeconds < 10 ? '0' : '') + remainingSeconds;
    }
    
    // التحكم في شريط التقدم
    let isDragging = false;
    
    progressBarContainer.addEventListener('mousedown', startDrag);
    progressBarContainer.addEventListener('touchstart', startDrag, { passive: true });
    
    function startDrag(e) {
      e.stopPropagation();
      isDragging = true;
      updateSeek(e);
      document.addEventListener('mousemove', updateSeek);
      document.addEventListener('touchmove', updateSeek, { passive: true });
      document.addEventListener('mouseup', stopDrag);
      document.addEventListener('touchend', stopDrag);
    }
    
    function updateSeek(e) {
      if (isDragging) {
        e.stopPropagation();
        const bounds = progressBarContainer.getBoundingClientRect();
        let x;
        
        if (e.type.startsWith('touch')) {
          x = e.touches[0].clientX - bounds.left;
        } else {
          x = e.clientX - bounds.left;
        }
        
        const percentage = Math.max(0, Math.min(100, (x / bounds.width) * 100));
        progressBar.style.width = percentage + '%';
        progressHandle.style.left = percentage + '%';
        
        // تحديث وقت الفيديو
        if (!isNaN(video.duration)) {
          video.currentTime = (percentage / 100) * video.duration;
        }
      }
    }
    
    function stopDrag() {
      isDragging = false;
      document.removeEventListener('mousemove', updateSeek);
      document.removeEventListener('touchmove', updateSeek);
      document.removeEventListener('mouseup', stopDrag);
      document.removeEventListener('touchend', stopDrag);
    }
    
    // إظهار/إخفاء عناصر التحكم
    let controlsTimeout;
    
    function showControls() {
      item.classList.add('active');
      clearTimeout(controlsTimeout);
      
      controlsTimeout = setTimeout(() => {
        item.classList.remove('active');
      }, 3000);
    }
    
    item.addEventListener('click', showControls);
    item.addEventListener('mousemove', showControls);
    item.addEventListener('touchstart', showControls, { passive: true });
    
    // إعادة تشغيل الفيديو عند انتهائه
    video.addEventListener('ended', function() {
      video.currentTime = 0;
      try {
        video.play().catch(err => console.error('خطأ في إعادة تشغيل الفيديو بعد الانتهاء:', err));
      } catch (e) {
        console.error('استثناء في إعادة تشغيل الفيديو بعد الانتهاء:', e);
      }
    });
  }

  /**
   * إغلاق نافذة الشورتس
   */
  closeShortsModal() {
    this.shortsModal.style.display = 'none';
    this.pauseAllVideos();
    
    const swipeGuide = this.shortsModal.querySelector('#swipeGuide');
    if (swipeGuide) {
      swipeGuide.classList.remove('visible');
    }
  }

  /**
   * إيقاف جميع الفيديوهات
   */
  pauseAllVideos() {
    if (!this.shortsScroller) return;
    
    const videos = this.shortsScroller.querySelectorAll('video');
    videos.forEach(video => {
      try {
        if (!video.paused) {
          video.pause();
        }
      } catch (e) {
        console.error('خطأ في إيقاف الفيديو:', e);
      }
    });
  }

  /**
   * تشغيل الفيديو النشط فقط
   */
  playActiveVideo(index) {
    if (!this.shortsScroller) return;
    
    const items = this.shortsScroller.querySelectorAll('.shorts-item');
    const videos = this.shortsScroller.querySelectorAll('video');
    
    videos.forEach((video, idx) => {
      if (idx === index) {
        // تحميل الفيديو النشط
        items[idx].classList.add('active');
        
        // إذا لم يكن لديه مصدر، تأكد من وجود العناصر source
        if (!video.src) {
          const sources = video.querySelectorAll('source');
          if (sources.length === 0) {
            // محاولة الحصول على مصدر من videoData
            if (this.videoData[index] && this.videoData[index].video && this.videoData[index].video.sources) {
              const videoSource = this.getBestVideoSourceForPlayback(this.videoData[index].video.sources);
              const videoUrl = this.validateAndFixVideoUrl(videoSource.url);
              
              const source = document.createElement('source');
              source.src = videoUrl;
              source.type = videoSource.mimeType || 'video/mp4';
              video.appendChild(source);
              video.load();
            }
          } else {
            video.load();
          }
        }
        
        // محاولة التشغيل
        setTimeout(() => {
          try {
            video.play().catch(err => {
              console.error('خطأ في تشغيل الفيديو النشط:', err);
              
              // محاولة إصلاح مصدر الفيديو إذا فشل التشغيل
              if (this.videoData[index] && this.videoData[index].video) {
                const videoId = this.extractVideoId(video.querySelector('source')?.src || '');
                if (videoId) {
                  const altVideoUrl = `https://cdn.shopify.com/videos/c/vp/${videoId}/${videoId}.mp4`;
                  
                  // إنشاء مصدر جديد
                  video.innerHTML = '';
                  const newSource = document.createElement('source');
                  newSource.src = altVideoUrl;
                  newSource.type = 'video/mp4';
                  video.appendChild(newSource);
                  video.load();
                  
                  // محاولة التشغيل مرة أخرى
                  setTimeout(() => {
                    video.play().catch(e => console.error('فشلت محاولة التشغيل الثانية:', e));
                  }, 500);
                }
              }
            });
          } catch (e) {
            console.error('استثناء في تشغيل الفيديو النشط:', e);
          }
        }, 100);
      } else {
        // إيقاف الفيديوهات الأخرى
        try {
          if (!video.paused) {
            video.pause();
          }
        } catch (e) {
          console.error('خطأ في إيقاف الفيديوهات الأخرى:', e);
        }
        items[idx].classList.remove('active');
      }
    });
  }

  /**
   * رصد التمرير العمودي
   */
  observeScrolling() {
    if (!this.shortsScroller) return;
    
    // استخدام Intersection Observer لتحديد الفيديو المرئي
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.8) {
          const currentItem = entry.target;
          const index = parseInt(currentItem.dataset.index);
          
          if (this.activeIndex !== index) {
            this.activeIndex = index;
            // تشغيل الفيديو المرئي فقط
            this.playActiveVideo(index);
          }
        }
      });
    }, { threshold: 0.8 });
    
    // مراقبة جميع عناصر الفيديو
    const items = this.shortsScroller.querySelectorAll('.shorts-item');
    items.forEach(item => {
      observer.observe(item);
    });
    
    // تشغيل الفيديو الأولي بعد فترة قصيرة
    setTimeout(() => {
      this.playActiveVideo(this.activeIndex);
    }, 200);
    
    // مستمع مفاتيح Escape للإغلاق
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.shortsModal.style.display === 'block') {
        this.closeShortsModal();
      }
    });
  }
} 